import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-error-modal-body',
  templateUrl: './subscription-error-modal-body.component.html',
  styleUrls: ['./subscription-error-modal-body.component.scss']
})
export class SubscriptionErrorModalBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
